import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/methodologies/$managedAccountMethodologyId/'
)({
  beforeLoad: ctx => {
    throw redirect({
      params: ctx.params,
      replace: true,
      to: '/methodologies/$managedAccountMethodologyId/associations'
    });
  }
});
